// src/components/CustomSelect.tsx
import React from 'react';
import { Select, SelectProps, MenuItem, InputLabel, FormControl, FormHelperText } from '@mui/material';
import { useController, Control } from 'react-hook-form';
import { SelectFieldOption } from '@/types';

type CustomSelectProps = SelectProps & {
  options: SelectFieldOption[];
  name?: string;
  control?: Control<any>;
}

const BaseSelect: React.FC<CustomSelectProps & { field?: any; fieldState?: any }> = (props) => {
  const { options, field, fieldState, label = 'Select', ...rest } = props;
  return (
    <FormControl fullWidth error={!!fieldState?.error}>
      <InputLabel>{label}</InputLabel>
      <Select {...field} {...rest} label={label}>
        {options.map(option => (
          <MenuItem key={option.value} value={option.value} disabled={Boolean(option?.disabled)}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {fieldState?.error && (
        <FormHelperText>{fieldState.error.message}</FormHelperText>
      )}
    </FormControl>
  );
};

const ControlledSelect: React.FC<CustomSelectProps> = (props) => {
  const { name, control } = props;
  const { field, fieldState } = useController({ name: name!, control: control! });
  return <BaseSelect {...props} field={field} fieldState={fieldState} />;
};

const CustomSelect: React.FC<CustomSelectProps> = (props) => {
  const { name, control } = props;
  return control && name ? <ControlledSelect {...props} /> : <BaseSelect {...props} />
};

export default CustomSelect;
